import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MmuUserService } from '../user-service/mmu-user.service';
import { MmuUserType } from '../models';

@Directive({
  selector: '[mmuUserType]'
})
export class MmuUserTypeDirective {
  private _isRendered = false;

  constructor(
    private userService: MmuUserService,
    private templateRef: TemplateRef<Element>,
    private viewContainerRef: ViewContainerRef) {}

  @Input()
  set mmuUserType(userType: MmuUserType) {
    if (this.checkPermission(userType)) {
      this.show();
    } else {
      this.hide();
    }
  }

  private checkPermission(userType: MmuUserType): boolean {
    return userType === this.userService.user.type;
  }

  private show(): void {
    if (!this._isRendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this._isRendered = true;
    }
  }

  private hide(): void {
    this.viewContainerRef.clear();
    this._isRendered = false;
  }
}
